import styled from 'styled-components';

import { IconSize } from '../../ui/Icon/Icon.style';
import { rem } from '../../utils';

const getSize = ({ size, theme }: { size?: IconSize; theme: any }): string =>
  (size && rem(theme.Icon.Size[size])) || '150px';

export const SpinnerContainer = styled.div<{ size?: IconSize }>`
  position: relative;
  display: block;
  width: ${getSize};
  height: ${getSize};
`;
